export const FETCH_DASHBOARD_DATA = 'FETCH_DASHBOARD_DATA';
export const FETCH_SALES_CHART = 'FETCH_SALES_CHART';
export const FETCH_MARGIN_CHART = 'FETCH_MARGIN_CHART';
export const EXPORT_MARGIN = 'EXPORT_MARGIN';
